import {
    FETCH_BARCODE_DATA_REQUEST,
    FETCH_BARCODE_DATA_SUCCESS,
    FETCH_BARCODE_DATA_FAILURE,
} from "constants/barcode";

export const fetchBarcodeDataRequest = (webSampleId) => ({
    type: FETCH_BARCODE_DATA_REQUEST,
    payload: {
        webSampleId
    }
});

export const fetchBarcodeDataSuccess = (payload) => ({
    type: FETCH_BARCODE_DATA_SUCCESS,
    payload: payload
});

export const fetchBarcodeDataFailure = (payload) => ({
    type: FETCH_BARCODE_DATA_FAILURE,
    payload: payload
});
